module.exports = __webpack_public_path__ + "static/media/icon-sunny-outline.cdcf5eff.svg";